//=============================================================================
//                       <--- Developed By Icon Team ---> 02 february 2021
//=============================================================================

// npm packages
import React, { useEffect, useContext, useState, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { CSVLink } from "react-csv";
import * as moment from "moment";
import Slide from "@material-ui/core/Slide";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import { useTranslation } from 'react-i18next';
import {pointsFormat, currencyFormat, tierRatioFormat} from "helpers/dataFormat"




// custom pages
import Context from "context/context";
import mpc from "apis/mpc/mpc";
// import product from "apis/Product/product";
import negativePoints from "apis/negativePoints/negativePoints";

import { negativePointsStyles } from "./styles";
import useDebounce from "helpers/useDebounce";
import Loader from "components/Loader/Loader";
import { exportHeaders,exportHeadersCa } from "./export";
import searchIcon from "assets/img/Search_Icon.png";
import audit from "apis/audit/audit";
import access from "config/access";
import HistoryTable from "components/Table/History/HistoryTable";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Table from "components/Table/Table";
import Button from "@material-ui/core/Button";
import InputAdornment from "@material-ui/core/InputAdornment";
import Grid from "@material-ui/core/Grid";
import FilterListIcon from "@material-ui/icons/FilterList";
import Card from "@material-ui/core/Card";
import Badge from "@material-ui/core/Badge";
import IconButton from "@material-ui/core/IconButton";
import MenuItem from "@material-ui/core/MenuItem";
import Dialog from "@material-ui/core/Dialog";

// material-ui icons
import SearchOutlinedIcon from "@material-ui/icons/SearchOutlined";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import MenuIcon from "@material-ui/icons/Menu";
import RemoveRedEyeIcon from "@material-ui/icons/RemoveRedEye";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import HistoryIcon from "@material-ui/icons/History";
import AuditAPI from "apis/audit/audit";

import { enUS, fr } from "date-fns/locale";



const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const sendEmailTransition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      marginTop: 0,
    },
  },
})(TextField);

const GlobalCss = withStyles({
  "@global": {
    ".MuiOutlinedInput-root": {
      borderRadius: 20,
      marginTop: 0,
    },
    '.MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
      padding: 0,
    },
  },
})(() => null);

export default function Locations(props) {
  const { state, dispatch } = useContext(Context);
  const { getnegativePointsList,search,productFilter,sendEmail,getHistoryApi,negativePointsExport,getAuditHistoryApi} =negativePoints();
  const classes = negativePointsStyles();
  const { getAudit, getAuditTableConfig } = AuditAPI();



  const [productData, setProductData] = useState([]);
  const [salesCategory, setSalesCategory] = useState([]);
  const [org, setOrg] = useState([]);
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [filterCard, setFilterCard] = useState(false);
  const [selectedOrg, setSelectedOrg] = useState({});
  const [selectedSales, setSelectedSales] = useState({});
  const [exportData, setExportData] = useState([]);
  const [response, setResponse] = useState({
    filter: false,
  });
  const [searchValue, setSearchValue] = useState("");
  const searchBounceValues = useDebounce(searchValue);
  const [isLoading, setIsLoading] = useState(false);
  const [emailPopOpen, setEmailPopOpen] = useState(false);
  const [mailType, setMailType] = useState('');
  
  const [data, setData] = useState(false);
  const [dropDownErrorText, setDropDownErrorText] = useState("");
  const [sendButton, setSendButton] = useState("Send");
  




  const [states, setstates] = useState({
    filter: false,
    salesCategory: "",
    redemptionFrom: null,
    redemptionTo: null,
    sortBy: "DESC",
    orderBy: "negative_count",
    orgName: "",
    isActive: "",
    historyLoader: false,
  });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  const { historyLoader } = states;

  const history = useHistory();
  const location = useLocation();

  // change pagination func
  const handlePagination = (value) => {
    setOffset(value);
  };
  const { t, i18n } = useTranslation()

  // For bread-crumbs
  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "Negative Points"],
    });
  }, []);

  // handling api calls
  useEffect(() => {
    if (state.userInfo && Object.keys(state.userInfo).length > 0) {
      states.filter
        ? handleFilter()
        : searchValue.length > 0
          ? handleSearch()
          : handleGetProduct();
    }
  }, [state.userInfo, offset]);

  // mpc api func
  const handleGetProduct = async () => {
    try {
      let values = {
        offset: (offset - 1) * 10,
        limit: 10,
      };
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await getnegativePointsList(values);
      if (res) {
        setProductData(res.data);
        setCount(res.count);
        dispatch({ type: "SET_LOADING", payload: false });
      }
    } catch (e) {
      console.log({ e });
    }
  };





  // handling search api
  useEffect(() => {
    let offsetValue = location?.state?.offset;
    if (searchBounceValues && searchBounceValues.length > 0) {
      handleSearch();
    } else if (offsetValue) {
      console.log(offsetValue,"offsetValue")
      setOffset(offsetValue);
      location.state = undefined;
    } else {
      setOffset(1);
    }
  }, [searchBounceValues]);

  // search api func
  const handleSearch = async () => {
    setStates({
      filter: false,
    });
    setResponse({ ...response, filter: false });
    setFilterCard(false);
    try {
      let values = {
        searchValue: searchValue,
        offset: (offset - 1) * 10,
        limit: 10,
      };
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await search(values);
      dispatch({ type: "SET_LOADING", payload: false });
      if (res) {
        setProductData(res.data);
        setCount(res.count);
        return;
      }
      setProductData([]);
    } catch (e) {
      dispatch({ type: "SET_LOADING", payload: false });
      console.log({ e });
    }
  };

  // filter api func
  const handleFilter = async () => {
    setStates({ filter: true });
    setSearchValue("");
    try {
      let values = {
        offset: (offset - 1) * 10,
        limit: 10,
        orderBy: states.orderBy,
        sortBy: states.sortBy,
      };
    
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await productFilter(values);
      // console.log(res,"hhhhhh")
      if (res) {
        setProductData(res.data);
        setCount(res.count);
        setFilterCard(false);
        setResponse({ filter: true });
        dispatch({ type: "SET_LOADING", payload: false });
      } else {
        setFilterCard(false);
      }
    } catch (e) {
      console.log({ e });
    }
  };
  const handleGetHistoryData = async (id) => {
    try {
      let values;
      
    
      if (id) {
        values = {
          loyaltyId: id
        };
      }
    
      let res = await getAuditHistoryApi(values);
      if (res) {
        setStates({ historyData: res?.data, historyLoader: false });
      }
    } catch (e) {
      console.log({ e });
    }
  };
  const handleGetSendbutton = async (id,emailType) => {
    try {
      let values;
    
      if (id) {
        values = {
          loyaltyId: id,
          type:emailType
        };
      }
    
      let res = await getHistoryApi(values);
      if (res&&res.data.length>0) {
        setSendButton("ReSend")

      }else{
        setSendButton("Send")

      }
    } catch (e) {
      console.log({ e });
    }
  };
  const handleGetSendbutton1 = async (p) => {
    try {
      let values;
      let emailType='';
      let loyaltyId=p?.loyalty_id;
      if(p?.negative_count>60&&p?.negative_count<=90){
        emailType='NEGATIVE_POINTS_NOTIFICATION_SIXTIETH_DAY'
      }
      else if(p?.negative_count>90&&p?.negative_count<180){
        emailType='NEGATIVE_POINTS_NOTIFICATION_NINETIETH_DAY'
      }
      if (loyaltyId) {
        values = {
          loyaltyId: loyaltyId,
          type:emailType
        };
      }    
      let res = await getHistoryApi(values);
      if (res&&res.data.length>0) {
        setSendButton("ReSend");
      }
      else{
        setSendButton("Send");
      }
    } 
    catch (e) {
      console.log({ e });
    }
  };
    // export api function
    const handleExport = async () => {
      let values = {};
      if (searchValue) {
        values = { ...values, searchValue };
      }
      if(states.filter){
        values = { ...values, filter:true,orderBy: states.orderBy,
          sortBy: states.sortBy, };
      }
    
     
      // dispatch({ type: "SET_LOADING", payload: true });
      setIsLoading(true);
      let res = await negativePointsExport(values);
      if (res && res.data) {
        setExportData(res.data)
      
        // dispatch({ type: "SET_LOADING", payload: false });
        setIsLoading(false);
        if (res.data.length === 0) {
          toast.success(t("No Data Found"), { toastId: "no-report-date" });
          return false;
        }
        return true;
      }
    };
  const handleSendEmail = async (id) => {
    try {
      let values;
      let mailType;
      if(data?.negative_count>60&&data?.negative_count<=90){
        mailType="NEGATIVE_POINTS_NOTIFICATION_SIXTIETH_DAY" 
      }
      if(data?.negative_count>90&&data?.negative_count<180){
        mailType="NEGATIVE_POINTS_NOTIFICATION_NINETIETH_DAY"
      }
      values = {
        loyaltyId: id,
        email_type: mailType ,
        negative_count:data?.negative_count
      };
      let res = await sendEmail(values);
      if (res) {
        if (res.type === "success") {
          setMailType("")

          history.push("/dashboard/upload-success", {
            type: i18n.language == 'fr' ? res.french_message : res.message,
          });
        } else {
          return toast.error(i18n.language == 'fr' ? res.french_message : res.message);
        }
      }
    } catch (e) {
      console.log({ e });
    }
  };

  const tableHeading =state?.userInfo?.loyalty_organization_name === "Henry Schein Dental" ? [
    "Loyalty Id",
    "Billto",
    "Current Balance",
    "Consecutive Negative (days)",
    "Day 1 Email",
     "60th Day Email",
     "90th Day Email",
    "View Detail"
  ]:[
    "Loyalty Id",
    "Billto",
    "Current Balance",
    "Consecutive Negative (days)",
    "",
     "",
     "",
    "View Detail"
  ];
 const handleGetEmailSendDate =(date,negativeCount) =>{
  const currentDate = new Date(); // This gets the current date

// Another date (e.g., '2023-01-15')
const specificDate = new Date(date);

// Find the difference in milliseconds
const differenceInMs = Math.abs(currentDate - specificDate);

// Convert milliseconds to days
const millisecondsInADay = 1000 * 60 * 60 * 24;
const differenceInDays = Math.floor(differenceInMs / millisecondsInADay);
console.log(differenceInDays,"differenceInDays")

return negativeCount-differenceInDays
 }
  

  const invalidChar = ['~', '`', '!', '#', '$', '%', '^', '*', '(', ')', '_', '+', '=', '', ';', ':', '<', '.', '>', '?', '|', '[', ']', '{', '}', '"', "'"]

  const blockInvalidChar = e => invalidChar.includes(e.key) && e.preventDefault();

  return (
    <React.Fragment>
      <GlobalCss />
      <Grid
        container
        spacing={0}
        onClick={() => {
          filterCard == true && setFilterCard(false);
        }}
      >
        {window.innerWidth < 600 && (
          <Grid xs={12}>
            <IconButton
              style={{ position: "absolute" }}
              onClick={() => {
                dispatch({ type: "SET_SIDEBAR", payload: true });
              }}
            >
              <MenuIcon />
            </IconButton>
            <span className={classes.headerText}>Product</span>
          </Grid>
        )}
        <Grid item xs={12} style={{ display: "flex", alignItems: "center" }}>
          <div style={{ flex: 0.99 }}>
            <CssTextField
              placeholder="Search for Loyalty Id"
              type={"text"}
              variant="outlined"
              onKeyDown={blockInvalidChar}
              className={classes.searchInput}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {searchValue.length > 0 ? (
                      <CloseOutlinedIcon
                        className={classes.searchInputIcon}
                        onClick={() => {
                          setSearchValue("");
                          setOffset(1);
                          handleGetProduct();
                        }}
                      />
                    ) : (
                      <img
                        src={searchIcon}
                        alt=""
                        width="20px"
                        className={classes.searchInputIcon}
                      />
                    )}
                  </InputAdornment>
                ),
              }}
              value={searchValue}
              onChange={(e) => {
                setSearchValue(e.target.value);
                setOffset(1);
                if (e.target.value.length == 0) {
                  handleGetProduct();
                }
              }}
              onClick={() => {
                setOffset(offset);
              }}
            />
            <Button
              className={`${classes.filterBtn} dash-1-filter-btn`}
              onClick={() => {
                setFilterCard(!filterCard);
                if (!states.filter) {
                  setStates({
                    expired: "",
                    startDate: null,
                    endDate: null,
                    type: [],
                    reason: "",

                  });
                }
              }}
            >
              {t('Filter')}
              {response["filter"] && (
                <Badge
                  badgeContent={count == 0 ? null : response["filter"] && count}
                  color="error"
                  classes={{ badge: classes.badge }}
                  max={999999}
                  className={classes.badges}
                ></Badge>
              )}
            </Button> 
          </div>
          <CSVLink
            id="csv"
            data={exportData}
            headers={state?.userInfo?.loyalty_organization_name === "Henry Schein Dental"?exportHeaders:exportHeadersCa
            }
            filename={
              `Negative Points` +
              " " +
              moment(new Date()).format("MM-DD-YYYY,h:mm A") +
              ".csv"
            }
            className={classes.CSVlink}
          />
          <button
            disabled={isLoading}
            className={classes.exportBtn}
            onClick={async () => {
              let res = await handleExport();
              if (res) {
                document.getElementById("csv").click();
              }
            }}
          >
              {isLoading ? (
              <div class="snippet" style={{ marginLeft: 55 }}>
                <div class="stage">
                  <div class="dot-typing-e"></div>
                </div>
              </div>
            ) :
              t(`Export`)
            }
          </button>
        </Grid>
      </Grid>
      
      {filterCard && (
        <div className={classes.filterCardDiv}>
          <Grid container spacing={0}>
            <Grid item xs={12} style={{ float: "right" }}>
              <Card className={classes.filterCard}>
                <Grid
                  container
                  spacing={2}
                  className={classes.filterCardGridContainer}
                >                      
                  <Grid item sm={4} xs={12} className={classes.filterCardGrid}>
                    <div className={classes.filterCardHeadText}>Order By</div>
                    <TextField
                      select
                      variant="outlined"
                      style={{ fontSize: "0.875rem !important", width: "100%" }}
                      type={"text"}
                      autoComplete="off"
                      value={states.orderBy}
                      onChange={(e) => {
                        setStates({ orderBy: e.target.value });
                      }}
                    >                          
                      <MenuItem value={"negative_count"}>Consecutive Negative (days)</MenuItem>
                      <MenuItem value={"points_balance"}>Points Balance</MenuItem>
                    </TextField>
                  </Grid>
                  <Grid item sm={4} xs={12} className={classes.filterCardGrid}>
                    <div className={classes.filterCardHeadText}>Sort</div>
                    {states?.orderBy=='points_balance'?<TextField
                      select
                      variant="outlined"
                      style={{ fontSize: "0.875rem !important", width: "100%" }}
                      type={"text"}
                      autoComplete="off"
                      value={states.sortBy}
                      onChange={(e) => {
                        setStates({ sortBy: e.target.value });
                      }}
                    >
                   
                      <MenuItem value={"ASC"}>Descending</MenuItem>
                      <MenuItem value={"DESC"}>Ascending</MenuItem>
                                             
                               
                    </TextField>:<TextField
                      select
                      variant="outlined"
                      style={{ fontSize: "0.875rem !important", width: "100%" }}
                      type={"text"}
                      autoComplete="off"
                      value={states.sortBy}
                      onChange={(e) => {
                        setStates({ sortBy: e.target.value });
                      }}
                    >
                   
                      <MenuItem value={"ASC"}>Ascending</MenuItem>
                      <MenuItem value={"DESC"}>Descending</MenuItem>
                                             
                               
                    </TextField>}
                  </Grid>                      
                  <Grid item sm={4} xs={12} className={classes.filterCardBtnGrid}                      >
                    <Grid container spacing={0}>
                      <Grid item xs={12}>
                        <Button
                          className={classes.filterCardApplyBtn}
                          onClick={() => {                                
                            handleFilter();
                            setCount(0);
                            setOffset(1);
                            setResponse({ filter: false });
                          }}
                        >
                          {t('Apply')}
                        </Button>
                      </Grid>
                      {states.filter && (
                        <Grid item xs={12}>
                          <Button
                            className={classes.filterCardResetBtn}
                            onClick={() => {
                              setStates({
                                filter: false,
                                type: "",
                                orderBy:"negative_count",
                                sortBy:"DESC",
                                startDate: null,
                                selectedtype: "",
                                endDate: null,
                                expired: "",
                                reason: "",
                                editObj: "",
                                updateObj: ""
                              });
                              setOffset(1);
                              setFilterCard(false);
                              handleGetProduct();
                              setCount(0);
                              setResponse({ filter: false });
                            }}
                          >
                            {t('Reset')}
                          </Button>
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </div>
      )}

      <Loader Loading={state.loading} top={"15%"}>
        <Grid container style={{ marginTop: 22 }}>
          <Grid item xs={12} sm={12} lg={12}>
            <div className={classes.tableDiv}>
              <Table
                headings={tableHeading.map((i) => (
                  <div
                    className={i === "Org name" ? classes.orgNameColumn : null}
                  >
                    {i}
                  </div>
                ))}
                data={productData.map((p, i) => [
                  p?.loyalty_id,
                  p?.customer_billto_account_number,
                  pointsFormat(p?.points_balance, i18n.language),
                  p?.negative_count,
                  state?.userInfo?.loyalty_organization_name === "Henry Schein Dental" ? p?.first_day?'Sent':'Not Sent':'',
                  state?.userInfo?.loyalty_organization_name === "Henry Schein Dental" ? [
                    <button
                    disabled={p?.negative_count<=60 || p?.negative_count>90 || p?.sixity_day}
                      className={(p?.negative_count<=60 || p?.negative_count>90 || p?.sixity_day )?classes.sendEmailBtnDisable:classes.sendEmailBtn}
                      onClick={()=>{
                        setEmailPopOpen(true)
                        setData(p)
                        setMailType("");
                        handleGetSendbutton1(p)  
                      }}                    
                    >
                      {p?.sixity_day?'Already Sent':'Send Email'}
                    </button>
                    
                  ]:'',
                  state?.userInfo?.loyalty_organization_name === "Henry Schein Dental" ? [
                    <button
                    disabled={p?.negative_count<=89||p?.ninity_day}
                      className={(p?.negative_count<=89||p?.ninity_day)?classes.sendEmailBtnDisable:classes.sendEmailBtn}
                      onClick={()=>{
                        setEmailPopOpen(true)
                        setData(p)
                        setMailType("");
                        handleGetSendbutton1(p)  
                      }}                    
                    >
                          {p?.ninity_day?'Already Sent':'Send Email'}
                    </button>
                    
                  ]:'',
                  (state?.userInfo?.auditAccess) && (
                    <RemoveRedEyeIcon
                      style={{ cursor: "pointer", verticalAlign: "middle" }}
                      onClick={() => {
                        history.push("/dashboard/negativedetail", {
                          loyaltyId:p,
                          offset,
                        });
                      }}
                      //   handleGetHistoryData(p?.loyalty_id);
                      // }}
                    />
                  ),
                ])}

               
                offset={offset}
                count={
                  (count / 10) % 1 == 0
                    ? Math.floor(count / 10)
                    : Math.floor(count / 10 + 1)
                }
                handlePagination={handlePagination}
              />
               <Loader loading={state.Loading}>
        <Dialog
          open={emailPopOpen}
          TransitionComponent={sendEmailTransition}
          keepMounted
          onClose={() => setEmailPopOpen(false)}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              <span
                style={{ float: "right", color: "red", cursor: "pointer" }}
                onClick={() => {
                  setMailType("");
                  setSendButton("Send")
                  setEmailPopOpen(false); 
                }}
              >
                X
              </span>

              <h1 style={{ textAlign: "center" }}>{(data?.negative_count > 60 && data?.negative_count < 90)? t('60th Day Email'):(data?.negative_count >= 90 && data?.negative_count)?t('90th Day Email'):t('Send Email')}</h1>
              {/* <h1 style={{ textAlign: "center" }}>  {data?.negative_count >= 90 && data?.negative_count < 180 && t('90th Day Email')}</h1> */}

              <div style={{ fontSize: 16, color: "#000", padding: "20px" }}>
              <Grid container>
        
        <Grid xs={12} lg={6} className={classes.grid}>
        <div>
            <span className={classes.gridSpan}>Loyalty Id</span> :{" "}
            {data.loyalty_id}
          </div>
               
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
        <div>
                <span className={classes.gridSpan}>Billto</span> :{" "}
            {data.customer_billto_account_number}
       
          </div>
        </Grid>


        <Grid xs={12} lg={6} className={classes.grid}>
                <div>
                <span className={classes.gridSpan}>Points Balance</span> :{" "}
            {data.points_balance}
           
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>

<div>
  <span className={classes.gridSpan}>Email Type</span> :{" "}
  {data?.negative_count > 60 && data?.negative_count < 90 && t('60th Day Email')}
  {data?.negative_count >= 90 && data?.negative_count < 180 && t('90th Day Email')}
</div>
</Grid>
        <Grid xs={12} lg={6} className={classes.grid}>

        <div>
                <span className={classes.gridSpan}>Consecutive Negative (days)</span> :{" "}
            {data.negative_count}
          </div>
        </Grid>
       

     
      </Grid>
           {/* {sendButton.toLowerCase()=='send'?"":<p>Note*: This Email is Already Sented</p>}   */}

                <div style={{ textAlign: "center" }}>
                  <button
                    className={classes.cancelBtn}
                    onClick={() => {
                    
                      setEmailPopOpen(false)
                      setMailType("")
                      setSendButton("Send")
                    }}
                  >
                    {t('Cancel')}
                  </button>

                  <button
                    className={classes.sendBtn}
                    onClick={()=>{
                      // if(mailType==''){
                      //   toast.error("Please select Email Type");
                      //   return;
                      // }
                      handleSendEmail(data?.loyalty_id)
                      setSendButton("Send")
                    }}
                  
                    // disabled={!access['editAccess'][state.userInfo?.role]['email-logs']}
                  >
                    {'Send'}
                    {/* {t(sendButton)} */}
                  </button>
                </div>
              </div>
            </DialogContentText>
          </DialogContent>
        </Dialog>
        
      </Loader>
      {/* Audit Logs Dialog */}
      <Dialog
        aria-labelledby="simple-dialog-title"
        open={states.historyDialog}
        style={{ fontFamily: "Segoe-ui" }}
        maxWidth={false}
      >
        <div className={classes.dialogParentDiv}>
          <div
            className={classes.parentText}
            style={{
              paddingBottom: 10,
              width: states?.historyData?.length > 0 ? "100%" : 300,
            }}
          >
            {t('History')}{" "}
            <span style={{ float: "right" }}>
              <HighlightOffIcon
                style={{
                  cursor: "pointer",
                  color: "red",
                  fontSize: 35,
                }}
                onClick={() => {
                  setStates({ historyDialog: false, historyData: [] });
                }}
              />
            </span>
          </div>

          {!historyLoader ? (
            <HistoryTable
              headings={[
                "Loyalty Id",
                "Description",
                "Date At"
              ]}
              data={
                states?.historyData?.length > 0 &&
                states?.historyData.map((d, i) => [
                  d?.record_id,
                  d?.old_value? d?.old_value == 0? 'Points balance went to negative':'Points balance went to positive':'',                  d?.reason
                ])
              }
              disablePagination={true}
            />
          ) : (
            <div>
              <Loader Loading={historyLoader} top={"15%"}></Loader>
            </div>
          )}
        </div>
      </Dialog>
            </div>
           
          </Grid>
        </Grid>
      </Loader>

     
    </React.Fragment>
  );
}
